import { Component, OnInit, OnDestroy, Input, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { SearchData } from '@sc/types';
import { SessionsService } from '../../services/sessions/sessions.service';
import { TeamsService } from '../../services/teams/teams.service';
import { UserData } from '@sc/types';
import { UserService } from '../../services/user/user.service';

@Component({
  selector: 'sc-team-list',
  templateUrl: './team-list.component.html',
  styleUrls: ['./team-list.component.scss'],
})
export class TeamListComponent implements OnInit, OnDestroy, OnChanges {
  @Input() team: Array<string> = [];
  @Input() checkParticipants = false;
  @Input() teamData: SearchData;
  @Input() overflowLimit = 4;

  team$ = this.teamsService.team$;
  participants$ = this.sessionsService.participants$;

  teamMembers: UserData[] = [];
  overflowParticipants = '';

  subs: Array<Subscription> = [];

  constructor(
    private teamsService: TeamsService,
    private sessionsService: SessionsService,
    private userService: UserService
  ) {}

  ngOnInit() {}

  async ngOnChanges(changes) {
    const team = changes.team?.currentValue;
    this.teamMembers = [];
    if (!this.checkParticipants) await this.team$.toPromise();
    if (this.checkParticipants) await this.participants$.toPromise();

    team?.forEach((uid) => {
      let foundMember = this.team$.value?.find((member) => member.uid === uid);
      if (!foundMember && this.checkParticipants) {
        const anonMember = this.participants$.value?.find((member) => member.uid === uid);
        if (anonMember) {
          foundMember = {
            uid: anonMember.uid,
            displayName: anonMember.name,
          };
        }
      }
      if (!foundMember && this.teamData && Object.keys(this.teamData?.participantInfo).includes(uid)) {
        foundMember = {
          uid,
          displayName: this.teamData.participantInfo[uid].name || this.teamData.participantInfo[uid].email,
        };
      }

      if (foundMember) {
        this.teamMembers.push(foundMember);
      } else {
        this.teamMembers.push({
          uid,
          displayName: uid,
        });
      }
    });

    this.teamMembers
      .sort((member1, member2) => (member1.photoURL ? -1 : 1))
      .sort((member1, member2) => (member1.uid === this.userService.activeUser$.value.uid ? -1 : 1));

    this.overflowParticipants = [...this.teamMembers]
      .splice(this.overflowLimit - 1)
      .map((participant) => participant.displayName || participant.fullName || participant.email)
      .join(', ');
  }

  ngOnDestroy() {
    this.subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
